import React from "react";

export const STATUS_LABELS = {
  draft: "Draft",
  needs_research: "Needs Research",
  awaiting_member_approval: "Awaiting Member Approval",
  requested: "Requested",
  researching: "Researching",
  placed_with_vendor: "Placed With Vendor",
  receiving: "Receiving",
  ready: "Ready",
  closed: "Closed",
  cancelled: "Cancelled",
};

// Forward-progress flow shown in the stepper (excludes terminal states).
export const FLOW = ["requested", "researching", "placed_with_vendor", "receiving", "ready"];

// All keys, in canonical order — terminal states last.
export const ALL_STATUSES = [...FLOW, "closed", "cancelled"];

// Status-pill CSS class names use the new keys. CSS in index.css already maps
// `.status-{key}` to colors — see the .status-requested / .status-researching
// rules added in this iteration.
export function StatusPill({ status, className = "" }) {
  const cls = `status-pill status-${status} ${className}`.trim();
  return <span className={cls}>{STATUS_LABELS[status] || status}</span>;
}

export function StatusStepper({ status }) {
  if (status === "cancelled") {
    return (
      <div className="flex items-center gap-3 text-sm">
        <span className="status-pill status-cancelled">Cancelled</span>
        <span className="text-[#7a7a7a]">This order is no longer active.</span>
      </div>
    );
  }
  if (status === "closed") {
    return (
      <div className="flex items-center gap-3 text-sm">
        <span className="status-pill status-closed">Closed</span>
        <span className="text-[#7a7a7a]">This order has been picked up. Thank you.</span>
      </div>
    );
  }
  const currentIdx = FLOW.indexOf(status);
  // Shorter labels for the stepper so they don't overlap on narrow viewports.
  const STEP_LABELS = {
    requested: "Requested",
    researching: "Researching",
    placed_with_vendor: "Placed",
    receiving: "Receiving",
    ready: "Ready",
  };
  return (
    <div className="w-full">
      <div className="flex items-start w-full">
        {FLOW.map((s, idx) => {
          const isDone = idx < currentIdx;
          const isCurrent = idx === currentIdx;
          return (
            <React.Fragment key={s}>
              <div className="flex flex-col items-center gap-2 flex-1 min-w-0 px-1">
                <div
                  className={`stepper-dot ${isDone ? "is-done" : ""} ${isCurrent ? "is-current" : ""}`}
                />
                <div
                  className={`text-[10px] sm:text-[0.65rem] tracking-[0.14em] sm:tracking-[0.18em] uppercase font-semibold text-center leading-tight ${
                    isDone || isCurrent ? "text-[#1A422D]" : "text-[#a8a8a8]"
                  }`}
                >
                  {STEP_LABELS[s]}
                </div>
              </div>
              {idx < FLOW.length - 1 && (
                <div className={`stepper-line mt-1.5 mx-1 sm:mx-2 flex-shrink-0 ${isDone ? "is-done" : ""}`} style={{ width: "12px" }} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
